var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53859 13.647L0.295955 9.40435C0.00306175 9.11146 0.0368371 8.60281 0.371394 8.26825C0.705951 7.9337 1.2146 7.89992 1.50749 8.19282L5.21981 11.9051L16.6608 0.464182C16.9953 0.129625 17.504 0.09585 17.7968 0.388743C18.0897 0.681637 18.056 1.19028 17.7214 1.52484L5.6747 13.5716C5.34014 13.9061 4.83149 13.9399 4.5386 13.647C4.5386 13.647 4.53859 13.647 4.53859 13.647Z",
    fill: "#883E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickPurple);
export default __webpack_public_path__ + "static/media/tick-purple.35bbf655bbf2c2fac4270b077386a2d9.svg";
export { ForwardRef as ReactComponent };